import React, { Fragment, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import { Stats } from "../components/Hero";
import {
  ContentSideBySide,
  ContentSideBySideCustom,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  SpacerV,
  FeatureCard,
  FeatureCardSmall,
} from "../components/Hero";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WindowIcon from "@mui/icons-material/Window";
import TabIcon from "@mui/icons-material/Tab";
import DvrIcon from "@mui/icons-material/Dvr";
import BlurOnIcon from "@mui/icons-material/BlurOn";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import Lottie from "react-lottie";
import { useInView, useSpring, animated } from "@react-spring/web";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import {
  useSpringCarousel,
  useTransitionCarousel,
} from "react-spring-carousel";

export default function Cloud() {
  const state = useSelector((state) => state);

  const navigate = useNavigate();
  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [zoom1, zoom1api] = useSpring(() => ({
    from: { transform: "scale(1)" },
  }));

  const [zoom2, zoom2api] = useSpring(() => ({
    from: { transform: "scale(1)" },
  }));

  const { carouselFragment, slideToPrevItem, slideToNextItem } =
    useSpringCarousel({
      withLoop: true,
      items: [
        {
          id: "item-1",
          renderItem: (
            <section>
              <div className={"vidhero"}>
                <div
                  className="imgback"
                  style={{
                    marginTop: "-25px",
                    borderRadius: "25px",
                    backgroundColor: "white",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "50px",
                    color: "black",
                  }}
                >
                  <div
                    style={{
                      marginTop: "-25px",
                      borderRadius: "25px",
                    }}
                  >
                    <FormatQuoteIcon
                      style={{
                        fontSize: state.auth.isMobile ? "50px" : "80px",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      fontSize: state.auth.isMobile ? "20px" : "30px",
                    }}
                  >
                    The collaboration with your team has been nothing short of
                    extraordinary. Your innovative approach and attention to
                    detail have set a new benchmark in excellence. We're
                    thrilled to have partnered with you!
                  </div>
                  <div
                    style={{
                      borderRadius: "25px",
                    }}
                  >
                    <FormatQuoteIcon
                      style={{
                        fontSize: state.auth.isMobile ? "50px" : "80px",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      fontSize: state.auth.isMobile ? "15px" : "20px",
                    }}
                  >
                    -Sarah Miller
                  </div>
                  <div
                    style={{
                      fontSize: state.auth.isMobile ? "10px" : "16px",
                      color: "grey",
                    }}
                  >
                    CEO of TechVantage Solutions
                  </div>
                </div>
                <animated.div
                  onClick={() => {
                    slideToNextItem();
                  }}
                  onMouseEnter={() => {
                    zoom1api.start({
                      from: {
                        transform: "scale(1)",
                      },
                      to: {
                        transform: "scale(1.1)",
                      },
                    });
                  }}
                  onMouseLeave={() => {
                    zoom1api.start({
                      from: {
                        transform: "scale(1.1)",
                      },
                      to: {
                        transform: "scale(1)",
                      },
                    });
                  }}
                  style={{
                    display: state.auth.isMobile ? "none" : "flex",
                    position: "absolute",
                    width: "80px",
                    height: "80px",
                    border: "2px solid white",
                    borderRadius: "100px",
                    top: "20vh",
                    right: 75,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    ...zoom1,
                  }}
                >
                  <ArrowRightIcon
                    style={{ fontSize: "75px", color: "white" }}
                  />
                </animated.div>
                <animated.div
                  onClick={() => {
                    slideToPrevItem();
                  }}
                  onMouseEnter={() => {
                    zoom2api.start({
                      from: {
                        transform: "scale(1)",
                      },
                      to: {
                        transform: "scale(1.1)",
                      },
                    });
                  }}
                  onMouseLeave={() => {
                    zoom2api.start({
                      from: {
                        transform: "scale(1.1)",
                      },
                      to: {
                        transform: "scale(1)",
                      },
                    });
                  }}
                  style={{
                    display: state.auth.isMobile ? "none" : "flex",
                    position: "absolute",
                    width: "80px",
                    height: "80px",
                    border: "2px solid white",
                    borderRadius: "100px",
                    top: "32vh",
                    right: 75,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    ...zoom2,
                  }}
                >
                  <ArrowLeftIcon style={{ fontSize: "75px", color: "white" }} />
                </animated.div>
              </div>
            </section>
          ),
        },
        {
          id: "item-2",
          renderItem: (
            <section>
              <div className={"vidhero"}>
                <div
                  className="imgback"
                  style={{
                    marginTop: "-25px",
                    borderRadius: "25px",
                    backgroundColor: "white",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "50px",
                    color: "black",
                  }}
                >
                  <div
                    style={{
                      marginTop: "-25px",
                      borderRadius: "25px",
                    }}
                  >
                    <FormatQuoteIcon
                      style={{
                        fontSize: state.auth.isMobile ? "50px" : "80px",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      fontSize: state.auth.isMobile ? "20px" : "30px",
                    }}
                  >
                    CGT team knew how to turn an idea into a visual product. We
                    were impressed with the research they did with our
                    competitors to really understand our space & the product
                    we're creating.
                  </div>
                  <div
                    style={{
                      borderRadius: "25px",
                    }}
                  >
                    <FormatQuoteIcon
                      style={{
                        fontSize: state.auth.isMobile ? "50px" : "80px",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      fontSize: state.auth.isMobile ? "15px" : "20px",
                    }}
                  >
                    - Mohamed Shegow
                  </div>
                  <div
                    style={{
                      fontSize: state.auth.isMobile ? "10px" : "16px",
                      color: "grey",
                    }}
                  >
                    CEO at Sinta Inc.
                  </div>
                </div>
                <animated.div
                  onClick={() => {
                    slideToNextItem();
                  }}
                  onMouseEnter={() => {
                    zoom1api.start({
                      from: {
                        transform: "scale(1)",
                      },
                      to: {
                        transform: "scale(1.1)",
                      },
                    });
                  }}
                  onMouseLeave={() => {
                    zoom1api.start({
                      from: {
                        transform: "scale(1.1)",
                      },
                      to: {
                        transform: "scale(1)",
                      },
                    });
                  }}
                  style={{
                    display: state.auth.isMobile ? "none" : "flex",
                    position: "absolute",
                    width: "80px",
                    height: "80px",
                    border: "2px solid white",
                    borderRadius: "100px",
                    top: "20vh",
                    right: 75,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    ...zoom1,
                  }}
                >
                  <ArrowRightIcon
                    style={{ fontSize: "75px", color: "white" }}
                  />
                </animated.div>
                <animated.div
                  onClick={() => {
                    slideToPrevItem();
                  }}
                  onMouseEnter={() => {
                    zoom2api.start({
                      from: {
                        transform: "scale(1)",
                      },
                      to: {
                        transform: "scale(1.1)",
                      },
                    });
                  }}
                  onMouseLeave={() => {
                    zoom2api.start({
                      from: {
                        transform: "scale(1.1)",
                      },
                      to: {
                        transform: "scale(1)",
                      },
                    });
                  }}
                  style={{
                    display: state.auth.isMobile ? "none" : "flex",
                    position: "absolute",
                    width: "80px",
                    height: "80px",
                    border: "2px solid white",
                    borderRadius: "100px",
                    top: "32vh",
                    right: 75,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    ...zoom2,
                  }}
                >
                  <ArrowLeftIcon style={{ fontSize: "75px", color: "white" }} />
                </animated.div>
              </div>
            </section>
          ),
        },
        {
          id: "item-3",
          renderItem: (
            <section>
              <div className={"vidhero"}>
                <div
                  className="imgback"
                  style={{
                    marginTop: "-25px",
                    borderRadius: "25px",
                    backgroundColor: "white",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "50px",
                    color: "black",
                  }}
                >
                  <div
                    style={{
                      marginTop: "-25px",
                      borderRadius: "25px",
                    }}
                  >
                    <FormatQuoteIcon
                      style={{
                        fontSize: state.auth.isMobile ? "50px" : "80px",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      fontSize: state.auth.isMobile ? "20px" : "30px",
                    }}
                  >
                    Your company has redefined professionalism and creativity.
                    The results you delivered exceeded our expectations and have
                    had a profound impact on our business. Thank you for being
                    such an exceptional partner.
                  </div>
                  <div
                    style={{
                      borderRadius: "25px",
                    }}
                  >
                    <FormatQuoteIcon
                      style={{
                        fontSize: state.auth.isMobile ? "50px" : "80px",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      fontSize: state.auth.isMobile ? "15px" : "20px",
                    }}
                  >
                    -David Johnson
                  </div>
                  <div
                    style={{
                      fontSize: state.auth.isMobile ? "10px" : "16px",
                      color: "grey",
                    }}
                  >
                    CEO of BrightPath Enterprises
                  </div>
                </div>
                <animated.div
                  onClick={() => {
                    slideToNextItem();
                  }}
                  onMouseEnter={() => {
                    zoom1api.start({
                      from: {
                        transform: "scale(1)",
                      },
                      to: {
                        transform: "scale(1.1)",
                      },
                    });
                  }}
                  onMouseLeave={() => {
                    zoom1api.start({
                      from: {
                        transform: "scale(1.1)",
                      },
                      to: {
                        transform: "scale(1)",
                      },
                    });
                  }}
                  style={{
                    display: state.auth.isMobile ? "none" : "flex",
                    position: "absolute",
                    width: "80px",
                    height: "80px",
                    border: "2px solid white",
                    borderRadius: "100px",
                    top: "20vh",
                    right: 75,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    ...zoom1,
                  }}
                >
                  <ArrowRightIcon
                    style={{ fontSize: "75px", color: "white" }}
                  />
                </animated.div>
                <animated.div
                  onClick={() => {
                    slideToPrevItem();
                  }}
                  onMouseEnter={() => {
                    zoom2api.start({
                      from: {
                        transform: "scale(1)",
                      },
                      to: {
                        transform: "scale(1.1)",
                      },
                    });
                  }}
                  onMouseLeave={() => {
                    zoom2api.start({
                      from: {
                        transform: "scale(1.1)",
                      },
                      to: {
                        transform: "scale(1)",
                      },
                    });
                  }}
                  style={{
                    display: state.auth.isMobile ? "none" : "flex",
                    position: "absolute",
                    width: "80px",
                    height: "80px",
                    border: "2px solid white",
                    borderRadius: "100px",
                    top: "32vh",
                    right: 75,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    ...zoom2,
                  }}
                >
                  <ArrowLeftIcon style={{ fontSize: "75px", color: "white" }} />
                </animated.div>
              </div>
            </section>
          ),
        },
        {
          id: "item-4",
          renderItem: (
            <section>
              <div className={"vidhero"}>
                <div
                  className="imgback"
                  style={{
                    marginTop: "-25px",
                    borderRadius: "25px",
                    backgroundColor: "white",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "50px",
                    color: "black",
                  }}
                >
                  <div
                    style={{
                      marginTop: "-25px",
                      borderRadius: "25px",
                    }}
                  >
                    <FormatQuoteIcon
                      style={{
                        fontSize: state.auth.isMobile ? "50px" : "80px",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      fontSize: state.auth.isMobile ? "20px" : "30px",
                    }}
                  >
                    Working with your team has been an absolute pleasure. Your
                    dedication, expertise, and ability to deliver outstanding
                    results have significantly contributed to our success. We're
                    looking forward to many more collaborations ahead.
                  </div>
                  <div
                    style={{
                      borderRadius: "25px",
                    }}
                  >
                    <FormatQuoteIcon
                      style={{
                        fontSize: state.auth.isMobile ? "50px" : "80px",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      fontSize: state.auth.isMobile ? "15px" : "20px",
                    }}
                  >
                    - Emily Carter
                  </div>
                  <div
                    style={{
                      fontSize: state.auth.isMobile ? "10px" : "16px",
                      color: "grey",
                    }}
                  >
                    CEO of GreenWay Innovations
                  </div>
                </div>
                <animated.div
                  onClick={() => {
                    slideToNextItem();
                  }}
                  onMouseEnter={() => {
                    zoom1api.start({
                      from: {
                        transform: "scale(1)",
                      },
                      to: {
                        transform: "scale(1.1)",
                      },
                    });
                  }}
                  onMouseLeave={() => {
                    zoom1api.start({
                      from: {
                        transform: "scale(1.1)",
                      },
                      to: {
                        transform: "scale(1)",
                      },
                    });
                  }}
                  style={{
                    display: state.auth.isMobile ? "none" : "flex",
                    position: "absolute",
                    width: "80px",
                    height: "80px",
                    border: "2px solid white",
                    borderRadius: "100px",
                    top: "20vh",
                    right: 75,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    ...zoom1,
                  }}
                >
                  <ArrowRightIcon
                    style={{ fontSize: "75px", color: "white" }}
                  />
                </animated.div>
                <animated.div
                  onClick={() => {
                    slideToPrevItem();
                  }}
                  onMouseEnter={() => {
                    zoom2api.start({
                      from: {
                        transform: "scale(1)",
                      },
                      to: {
                        transform: "scale(1.1)",
                      },
                    });
                  }}
                  onMouseLeave={() => {
                    zoom2api.start({
                      from: {
                        transform: "scale(1.1)",
                      },
                      to: {
                        transform: "scale(1)",
                      },
                    });
                  }}
                  style={{
                    display: state.auth.isMobile ? "none" : "flex",
                    position: "absolute",
                    width: "80px",
                    height: "80px",
                    border: "2px solid white",
                    borderRadius: "100px",
                    top: "32vh",
                    right: 75,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    ...zoom2,
                  }}
                >
                  <ArrowLeftIcon style={{ fontSize: "75px", color: "white" }} />
                </animated.div>
              </div>
            </section>
          ),
        },
      ],
    });

  useEffect(() => {
    const timer = setInterval(() => {
      slideToNextItem();
    }, 10000);
    return () => {
      window.clearInterval(timer);
    };
  }, [slideToNextItem]);

  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <Hero
  background={
    "linear-gradient(135deg, #992619 0%, #8e0e00 50%, #7f0c00 100%)"
  }
  title="Cloud Solutions"
  subtitle={
    <div>
      <p>
        Our company specializes in delivering cutting-edge cloud solutions 
        tailored to your business needs. Here’s why you should choose us:
      </p>
      {!state.auth.isMobile ? (
        <ul>
          <li>
            <strong>Scalable Infrastructure</strong>: We provide robust cloud 
            services that scale with your business, ensuring high performance 
            and reliability.
          </li>
          <li>
            <strong>Secure & Compliant</strong>: Our cloud solutions prioritize 
            security, compliance, and data protection to safeguard your business.
          </li>
          <li>
            <strong>Cost-Efficient Solutions</strong>: Optimize your IT 
            infrastructure with flexible cloud models, reducing costs while 
            improving operational efficiency.
          </li>
        </ul>
      ) : (
        ""
      )}
      <p>
        Partner with us to leverage the power of cloud computing, transforming 
        your business with agility, security, and scalability.
      </p>
    </div>
  }
/>

        {/* <div className="overlay2"></div>

        <img
          src={require("../img/888.jpg")}
          className="imgback"
          style={{ height: "80%" }}
        />
        <div
          className="content"
          style={{
            position: "absolute",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100vw",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              width: "75vw",
            }}
          >
            <div
              style={{
                paddingTop: state.auth.isMobile ? "100px" : "0px",
                fontSize: state.auth.isMobile ? "60px" : "75px",
                color: "white",
                zIndex: 999,
                textAlign: state.auth.isMobile ? "left" : "center",
                fontWeight: 600,
              }}
            >
              Hybrid Cloud Services
            </div>

            <div
              style={{
                borderBottom: "2px solid white",
                width: "100%",
                margin: "50px 0px 50px 0px",
                zIndex: 999,
              }}
            ></div>
            <div
              style={{
                fontSize: state.auth.isMobile ? "30px" : "40px",
                color: "white",
                zIndex: 999,
                textAlign: state.auth.isMobile ? "left" : "center",
              }}
            >
              Secure and managed cloud solutions
            </div>
          </div>
        </div>
        <div style={{ height: "100vh" }}></div>
        <div style={{ height: "100px" }}></div> */}

        <ContentSideBySideInv
          title="Unlock innovation with the right Startup Cloud Solutions"
          subtitle={
            <div>
              Cloud technology has become a key driver of transformation, yet
              many organizations face substantial obstacles in scaling their
              cloud capabilities. Businesses often find it challenging to
              demonstrate the value of their transformation efforts or to align
              IT investments with tangible business outcomes. At CGT Solutions,
              our Hybrid Cloud Services offer a comprehensive strategy to
              pinpoint and address these challenges, ensuring a seamless path
              toward innovation and growth.
            </div>
          }
          image={
            <img style={{ width: "100%" }} src={require("../img/222.jpg")} />
          }
        />
        <SpacerV height={"100px"} />
        <div
          style={{
            paddingTop: "50px",
            paddingBottom: "100px",
          }}
        >
          <TabContext value={value}>
            {!state.auth.isMobile ? (
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  display: "flex",
                  justifyContent: "center",
                  fontSize: "50px",
                  background: "transparent",
                  maxWidth: "100vw",
                }}
              >
                <TabList
                  onChange={handleChange}
                  aria-label="cloud service providers"
                >
                  <Tab
                    label="AWS Cloud Services"
                    value="1"
                    style={{ fontSize: "22px", color: "black" }}
                  />
                  <Tab
                    label="Microsoft Azure"
                    value="2"
                    style={{ fontSize: "22px", color: "black" }}
                  />
                  <Tab
                    label="Google Cloud Platform"
                    value="3"
                    style={{ fontSize: "22px", color: "black" }}
                  />
                  <Tab
                    label="IBM Cloud"
                    value="4"
                    style={{ fontSize: "22px", color: "black" }}
                  />
                  <Tab
                    label="Oracle Cloud"
                    value="5"
                    style={{ fontSize: "22px", color: "black" }}
                  />
                </TabList>
              </Box>
            ) : (
              <div style={{ marginBottom: "-100px" }} />
            )}

            <TabPanel value="1">
              <ContentSideBySideCustom
                background={"transparent"}
                titleColor={"black"}
                subtitleColor={"#222"}
                titleFontSize={"22px"}
                subtitleFontSize={"20px"}
                title="Amazon Web Services (AWS) – Scalable and Secure Cloud Solutions"
                subtitle="Our team helps you harness the full potential of AWS by designing and implementing scalable, secure, and cost-effective cloud solutions. From setting up EC2 instances for virtual servers to optimizing S3 storage, we ensure your infrastructure is robust and efficient. We also integrate AWS Lambda for serverless computing, RDS for managed databases, and SageMaker for AI-driven innovation, enabling your business to scale seamlessly while maintaining industry-leading security."
                image={
                  <img
                    style={{
                      height: "50vh",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    src={require("../img/cloud1.png")}
                  />
                }
              />
            </TabPanel>

            <TabPanel value="2">
              <ContentSideBySideCustom
                background={"transparent"}
                titleColor={"black"}
                subtitleColor={"#222"}
                titleFontSize={"22px"}
                subtitleFontSize={"20px"}
                title="Microsoft Azure – Enterprise-Grade Cloud Computing"
                subtitle="We empower your business with Microsoft Azure’s hybrid, multi-cloud, and AI-driven capabilities. Our experts deploy Azure Virtual Machines for flexible computing power and Azure Kubernetes Service (AKS) for streamlined containerized applications. By leveraging Azure AI, machine learning, and IoT solutions, we help you drive innovation and efficiency. With seamless integration into Microsoft products like Office 365 and Active Directory, we ensure a smooth transition to Azure for your enterprise."
                image={
                  <img
                    style={{
                      height: "50vh",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    src={require("../img/cloud2.png")}
                  />
                }
              />
            </TabPanel>

            <TabPanel value="3">
              <ContentSideBySideCustom
                background={"transparent"}
                titleColor={"black"}
                titleFontSize={"22px"}
                subtitleFontSize={"20px"}
                subtitleColor={"#222"}
                title="Google Cloud Platform (GCP) – Data-Driven and AI-Powered Cloud"
                subtitle="Our team specializes in leveraging Google Cloud Platform (GCP) to deliver high-performance, data-driven, and AI-powered solutions. We deploy Compute Engine for virtual machines, Kubernetes Engine for containerized applications, and BigQuery for advanced data analytics. By integrating GCP’s AI/ML services, we help your business unlock the power of data science and automation. With Google’s secure global network, we ensure reliability and cost efficiency for your operations."
                image={
                  <img
                    style={{
                      height: "50vh",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    src={require("../img/cloud6.png")}
                  />
                }
              />
            </TabPanel>

            <TabPanel value="4">
              <ContentSideBySideCustom
                background={"transparent"}
                titleColor={"black"}
                titleFontSize={"22px"}
                subtitleColor={"#222"}
                subtitleFontSize={"20px"}
                title="IBM Cloud – AI-Driven and Hybrid Cloud Solutions"
                subtitle="We help your business thrive with IBM Cloud’s AI-driven and hybrid cloud solutions. Our experts implement IBM Watson AI for advanced analytics and automation, and IBM Cloud Pak for seamless cloud-native application development. We design hybrid models that support on-premise and multi-cloud deployments, making IBM Cloud ideal for regulated industries. With our support, you can leverage blockchain solutions and quantum computing research to stay ahead in technological innovation."
                image={
                  <img
                    style={{
                      height: "50vh",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    src={require("../img/cloud4.png")}
                  />
                }
              />
            </TabPanel>

            <TabPanel value="5">
              <ContentSideBySideCustom
                background={"transparent"}
                titleColor={"black"}
                subtitleColor={"#222"}
                titleFontSize={"22px"}
                subtitleFontSize={"20px"}
                title="Oracle Cloud – Performance-Optimized for Enterprise Workloads"
                subtitle="Our team ensures your enterprise benefits from Oracle Cloud Infrastructure (OCI)’s high-performance computing and database management capabilities. We deploy Autonomous Database for self-tuning, self-patching, and self-securing databases, reducing operational overhead. With low-latency networking, cost-effective cloud storage, and machine learning integration, we optimize OCI for mission-critical workloads. Let us help you achieve peak performance and scalability with Oracle Cloud."
                image={
                  <img
                    style={{
                      height: "50vh",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    src={require("../img/cloud5.png")}
                  />
                }
              />
            </TabPanel>
          </TabContext>
        </div>
        <div
          className="anigrad"
          style={{
            height: "100vh",
            maxWidth: "100vw",
            display: state.auth.isMobile ? "none" : "block",
          }}
        >
          <div style={{ width: "100%", height: "100%" }}>
            {carouselFragment}
          </div>
        </div>
        <SpacerV height={"100px"} />
        <ThreeSideBySide
          background={
            "linear-gradient(135deg, #992619 0%, #8e0e00 50%, #7f0c00 100%)"
          }
          spacing={5}
          subtitle1={
            <Fragment>
              <FeatureCardSmall
                minHeight={"50vh"}
                title={"Optimize your cloud strategy with CGT Solutions"}
                text={"with Public cloud services"}
                icon={
                  <TravelExploreIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
              <br />
              <br />
              <FeatureCardSmall
                minHeight={"50vh"}
                title={
                  "Modernize your enterprise with groundbreaking IT solutions"
                }
                text={"with Cloud Consulting"}
                icon={
                  <TravelExploreIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
            </Fragment>
          }
          subtitle2={
            <Fragment>
              <FeatureCard
                minHeight={"50vh"}
                title={"Choose the right cloud provider"}
                text={`We are here to turn your complex challenges into simple and
                streamlined solutions. We engineer comprehensive and scalable
                software solutions. Our agile team has intuitive interfaces to
                work fast and smart tot deliver projects quickly`}
                icon={
                  <DvrIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
            </Fragment>
          }
          subtitle3={
            <Fragment>
              <FeatureCardSmall
                minHeight={"50vh"}
                title={"Transform your IT operating model"}
                text={"with Modern Operations"}
                icon={
                  <TravelExploreIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
              <br />
              <br />
              <FeatureCardSmall
                minHeight={"50vh"}
                title={
                  "Maximize your IT infrastructure with performance and efficiency"
                }
                text={"with Managed Cloud Services"}
                icon={
                  <TravelExploreIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
            </Fragment>
          }
        />
        <Stats />
        <div style={{ height: "100px" }}></div>

       
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
